import axios from "axios";
import './user';

window.axios = axios;

let sidebar = document.querySelector("#sidebar_menu");
let width = document.body.clientWidth;

if (width >= 1200) {
    sidebar.classList.add("open");
    sidebar.style.display = 'block';
}else{
    sidebar.classList.remove("open");
    sidebar.style.display = 'none';
}

window.addEventListener("resize", function (event) {
    let width = document.body.clientWidth;

    if (width >= 1200) {
        sidebar.classList.add("open");
        sidebar.style.display = 'block';

    } else {
        sidebar.classList.remove("open");
        sidebar.style.display = 'none';
    }
});

var gamesLoading = false;

function loadMoreGamesContent() {

    if (gamesLoading) {
        return; // Prevent multiple requests
    }

    let $gameList = $('#gameList');

    let nextLink = $('.next-link').attr('href');

    if (!nextLink)
        return;

    nextLink = nextLink.replace(/http.+?\/\/[^\/]+/gi,'');

    gamesLoading = !($gameList.next().find('.loading_ring').css('display') === 'none');

    if ($(window).scrollTop() + $(window).height() >= $gameList.offset().top + $gameList.outerHeight() && !gamesLoading) {

        $gameList.next().find('.loading_ring').css('display','block');

        $.ajax({
            url: nextLink,
            type: 'GET',
            success: function (data) {
                if (data) {

                    let $data = $(data);
                    let nextSection = $data.find('#gameList').get(0);
                    let nextLink = $data.find('.next-link').attr('href');

                    if (!nextLink) {
                        $(window).off('scroll',loadMoreGamesContent);
                    } else {
                        $('.next-link').attr('href', nextLink);
                    }

                    $gameList.append(nextSection.innerHTML);

                }

                setTimeout(function () {
                    $gameList.next().find('.loading_ring').css('display','none');
                    gamesLoading = false;
                }, 200);

            },
            error: function (error) {

                setTimeout(function () {
                    $gameList.next().find('.loading_ring').css('display','none');
                    gamesLoading = false;
                }, 5000);

            }

        })

    }

};

(function ($) {

    if ($('#gameList').length) {

        $(window).on('scroll',loadMoreGamesContent);
        $(window).on('load',loadMoreGamesContent);

    }
    //
})(jQuery);
